import { createContext } from 'react';

import { PageLoadData } from './types';

export interface PageDataLoadContextValue {
  readonly pageLoadData: PageLoadData;
}

export const PageDataLoadContext = createContext<PageDataLoadContextValue | undefined>(undefined);
